var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1365_7754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "#512BD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70322 20.4448C5.47696 20.4448 5.28464 20.3694 5.12625 20.2186C4.96787 20.064 4.88867 19.8803 4.88867 19.6677C4.88867 19.4511 4.96787 19.2656 5.12625 19.1109C5.28464 18.9562 5.47696 18.8789 5.70322 18.8789C5.93325 18.8789 6.12747 18.9562 6.28585 19.1109C6.44801 19.2656 6.52909 19.4511 6.52909 19.6677C6.52909 19.8803 6.44801 20.064 6.28585 20.2186C6.12747 20.3694 5.93325 20.4448 5.70322 20.4448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7486 20.3168H13.2778L9.4031 14.2039C9.30506 14.0493 9.22394 13.8888 9.15987 13.7225H9.12591C9.15608 13.9004 9.17117 14.2813 9.17117 14.8651V20.3168H7.87012V12H9.43699L13.1817 17.9679C13.3401 18.2154 13.4419 18.3855 13.4872 18.4783H13.5098C13.4721 18.258 13.4532 17.8848 13.4532 17.3589V12H14.7486V20.3168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0843 20.3168H16.5308V12H20.9033V13.1716H17.8771V15.5262H20.6658V16.692H17.8771V19.1511H21.0843V20.3168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5554 13.1716H25.2249V20.3168H23.8786V13.1716H21.5537V12H27.5554V13.1716Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1365_7754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNet);
export default __webpack_public_path__ + "static/media/net.f1a9708f1880eeca8dce4e29fbd54aec.svg";
export { ForwardRef as ReactComponent };